import { createRequestTypes } from '../utils';

export const TASKTYPE_LIST = createRequestTypes('taskType/TASKTYPE_LIST');
export const ADD_TASKTYPE = 'taskType/ADD_TASKTYPE';
export const EDIT_TASKTYPE = 'taskType/EDIT_TASKTYPE';
export const SAVE_TASKTYPE = createRequestTypes('taskType/SAVE_TASKTYPE');
export const DELETE_TASKTYPE = createRequestTypes('taskType/DELETE_TASKTYPE');
